enum VisualizationErrorType {
    Configuration = 'configuration',
    Execution = 'execution',
    Worker = 'worker',
}

class VisualizationError extends Error {
    type: string;
    message: string;
    queryId?: string;
    visualizationId?: string;
    executionId?: string;
    constructor(props: {
        type: VisualizationErrorType;
        message: string;
        queryId?: string;
        visualizationId?: string;
        executionId?: string;
    }) {
        super();
        this.type = props.type;
        this.message = props.message;
        this.queryId = props.queryId;
        this.visualizationId = props.visualizationId;
        this.executionId = props.executionId;
    }
}

export { VisualizationError, VisualizationErrorType };
